import { API_BASE, API_URL, APPLICATION_JSON_HEADER } from "@/constants";
import { SuccessResponse } from "@/types/api/shared";
import { getApiError } from "@/utils/api-error";

import { ContactFormFields } from "./types";

const ENDPOINT = `${API_URL}${API_BASE}/proxy-contact`;
export async function postHelpRequest(body: ContactFormFields) {
  const response = await fetch(ENDPOINT, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      ...APPLICATION_JSON_HEADER,
    },
  });
  if (!response.ok) {
    throw await getApiError(response);
  }
  return response.json() as Promise<SuccessResponse>;
}
